import { PublicClientApplication } from "@azure/msal-browser";
import { LogLevel } from '@azure/msal-browser';
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_URI,
  },
  cache: {
    cacheLocation: "localStorage",//"localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Verbose,
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],//
  extraQueryParameters: {
    domain_hint: "us.mcd.com", // Hardcoded domain
  },
};
export const msalInstance = new PublicClientApplication(msalConfig);